<div class="section">
  <div class="content no-padding">
    <div class="col">
      <div class="content no-padding">
        <div class="title">Profile &nbsp;</div>
        <span
          *ngIf="isEditable()"
          class="text mark-down"
          (click)="openUpdateUserWizard('update_fusion_sso_user')"
          i18n="update link profile|Update link into profile page@@updateLinkProfilePage"
        >
          Update</span
        >
      </div>
      <div class="sub-content">
        <div>{{ userInfo.company }}</div>
        <div i18n="@@userRoleProfilePage">{{ userInfo.jobRole }}</div>
        <div>{{ userInfo.country }} {{ userInfo.busPhone }}</div>
      </div>
    </div>
    <div class="col">
      <div class="content no-padding">
        <span
          class="text readonly"
          i18n="last login profile|Last login info into profile page@@lastLoginProfilePage"
          >Last login: {{ lastLogin }}</span
        >
      </div>
    </div>
  </div>
  <div class="content">
    <!--
    <div class="col">
      <div class="text title" i18n="avatar title|Avatar title into profile page@@avatarTitleProfilePage">Avatar</div>
      <div class="content no-padding">
        <i class="mdi mdi-account-box user-icon"></i>
        <div class="col">
          <span class="text mark-down" *ngFor="let avatar of userProfile.avatars">
            <a class="text mark-down" href="{{ avatar.url }}">{{ avatar.title }}</a>
            <span class="info-tooltip">
              <span class="tooltip-container">{{avatar.tooltip}}</span>
            </span>
          </span>
        </div>
      </div>
    </div>
    -->
    <div class="col">
      <div class="text title">Name</div>
      <div class="content no-padding">
        <div class="col">
          <span class="text readonly">{{ userInfo.name }} {{ userInfo.surname }}</span>
        </div>
      </div>
    </div>
    <div class="col">
      <div
        class="text title"
        i18n="email title|Email title into profile page@@emailAddressProfilePage"
      >
        Email address
      </div>
      <div class="content no-padding">
        <div class="col">
          <span class="text readonly">{{ userInfo.email }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
